import { Delete, Edit, TextFields } from "@mui/icons-material";

import { SetStateAction, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
  Menu,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { styles } from "../styles";
import { AgendamentoGroup } from "../../../../pages/easyReport/agendamento";

interface MenuGroupProps {
  anchorEl: null | HTMLElement;
  handleClose: () => void;
  open: boolean;
  selectedGroup: AgendamentoGroup | null;
  onRenameGroup: (newName: string) => void;
  onDeleteGroup?: () => void;
  setEditMode: () => void;
  setAnchorEl: React.Dispatch<SetStateAction<HTMLButtonElement | null>>;
  setDeleteModal: React.Dispatch<SetStateAction<boolean>>;
}

export default function MenuGroup({
  anchorEl,
  setAnchorEl,
  handleClose,
  open,
  selectedGroup,
  onRenameGroup,
  setEditMode,
  setDeleteModal,
}: MenuGroupProps) {
  const [openRenameGroupModal, setOpenRenameGroupModal] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");

  useEffect(() => {
    if (openRenameGroupModal && selectedGroup) {
      setNewGroupName(selectedGroup.titulo);
    }
  }, [openRenameGroupModal, selectedGroup]);

  const handleRename = () => {
    if (newGroupName.trim()) {
      setAnchorEl(null);
      onRenameGroup(newGroupName.trim());
      setOpenRenameGroupModal(false);
    }
  };

  return (
    <>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `options-button-${selectedGroup?.id}`,
        }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              setOpenRenameGroupModal(true);
            }}
          >
            <ListItemIcon>
              <TextFields fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Renomear</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              setEditMode();
              handleClose();
            }}
          >
            <ListItemIcon>
              <Edit fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Editar</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setDeleteModal(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <Delete fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText>Excluir</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>

      <Dialog
        open={openRenameGroupModal}
        onClose={() => {
          setOpenRenameGroupModal(false);
        }}
      >
        <DialogTitle color="primary">
          Renomear grupo
          <IconButton
            aria-label="Fechar"
            onClick={() => {
              setOpenRenameGroupModal(false);
            }}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.text.secondary,
            })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Typography component="label" htmlFor="rename-group-title">
            Título
          </Typography>
          <TextField
            id="rename-group-title"
            placeholder="Título do grupo"
            size="small"
            value={newGroupName}
            sx={styles.textfield}
            autoComplete="off"
            onChange={(e) => setNewGroupName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={styles.buttonCancelDialog}
            onClick={() => {
              setAnchorEl(null);
              setOpenRenameGroupModal(false);
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleRename}
            disabled={!newGroupName.trim()}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
